import React, { useEffect } from "react";
import { Outlet, Route, Routes, useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { authRoutes, publicRoutes } from "./router.link";
import Header from "../components/common/header";
import Sidebar from "../components/common/sidebar";
import { useAppSelector } from "../store/store";
import routePermissions from "./routePermissions";
import sendRequest from "../helpers/service";
import { setUserAccessPages } from "../store/userSlice";

const ErrorPage = React.lazy(() => import("./../screens/general/ErrorPage"));

const ALLRoutes = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useAppSelector((state) => state.user.data);
  const pageMap = useAppSelector((state) => state.user.pageMap);

  //Her sayfa açılışında rol izinleri DB'den taze çekilip token/pageMap güncellenir,
  //böylece yetki değişiklikleri için tekrar giriş yapmak gerekmez.
  useEffect(() => {
    if (!user) {
      return;
    }

    sendRequest
      .get({ url: "permissions/refresh" })
      .then((res: any) => {
        dispatch(setUserAccessPages(res.pages));
      })
      .catch(() => {});
  }, [location.pathname, user]);

  const HeaderLayout = () => (
    <>
      <Header />
      <Sidebar />
      <Outlet />
    </>
  );
  function getPagePermissions(pageType: string) {
    const returnValue: any = {};
    const pagePermissions = routePermissions[pageType];

    for (const pageName in pagePermissions) {
      returnValue[pageName] = pageMap[pageName]?.permissions;
    }

    return returnValue;
  }

  console.log("@user", user);

  return (
    <>
      <Routes>
        {user ? (
          <Route path={"/"} element={<HeaderLayout />}>
            {publicRoutes.map((route) => {
              const canAccess = pageMap[route.pageType]?.canReach;
              return (
                <Route
                  path={route.path}
                  element={
                    canAccess ? (
                      <route.Content
                        //@ts-ignore
                        permissions={getPagePermissions(route.pageType)}
                      />
                    ) : (
                      <ErrorPage />
                    )
                  }
                  key={route.path}
                />
              );
            })}
          </Route>
        ) : (
          <>
            {authRoutes.map((route, idx) => (
              <Route path={route.path} element={<route.Content />} key={idx} />
            ))}
          </>
        )}
      </Routes>
    </>
  );
};

export default ALLRoutes;
